module.exports = __webpack_public_path__ + "img/order_status.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/order_status.png
// module id = 935
// module chunks = 0